import React, { useMemo } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import Moment from "react-moment";
import _ from "lodash";


const normalizeDoc = (d) => {
  const name =
    d.document_descriptor_name ||
    d.document_descriptor?.name ||
    "Documento sin nombre";

  const url = d.download_url || d.document || null;

  return {
    id: d.id,
    name,
    updated_at: d.updated_at,
    url,
    uploaded: typeof d.uploaded === "boolean" ? d.uploaded : Boolean(url)
  };
};

const collectFromPersonalDocs = (applicant) => {
  const candidates =
    applicant?.personal_documents ||
    applicant?.personalDocuments ||
    applicant?.documents ||
    [];
  return Array.isArray(candidates) ? candidates.map(normalizeDoc) : [];
};

const collectFromStages = (applicant) => {
  const posts = applicant?.postulations || [];
  const stageDocs = posts.flatMap((p) =>
    (p?.applicant?.enrollment?.stages || []).flatMap(
      (s) => s?.requested_documents || []
    )
  );
  return stageDocs.map(normalizeDoc);
};

const buildDocumentList = (applicant) => {
  const a = collectFromPersonalDocs(applicant);
  const b = collectFromStages(applicant);
  const merged = [...a, ...b].filter((d) => d.uploaded);

  const deduped = _.uniqBy(
    merged,
    (d) => `${d.url || "no-url"}::${d.name.toLowerCase()}::${d.id}`
  );

  return deduped.sort((x, y) => new Date(y.updated_at) - new Date(x.updated_at));
};

const ApplicantDocuments = ({ applicant }) => {
  const documents = useMemo(() => buildDocumentList(applicant), [applicant]);

  if (!documents || documents.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        <i className="fas fa-info-circle fa-2x mb-3 d-block" aria-hidden="true"></i>
        <p className="mb-0">Este candidato aún no tiene documentos cargados.</p>
      </div>
    );
  }

  return (
    <>
      {documents.map((d) => (
        <Card key={`${d.id}-${d.url || "nou"}`} className="mb-2 material-shadow">
          <CardBody>
            <Row className="align-items-center">
              <Col md="6" className="d-flex align-items-center">
                <i className="far fa-file me-2 text-secondary" aria-hidden="true" />
                <span className="fw-bold">{d.name}</span>
              </Col>
              <Col md="3" className="text-md-center mt-2 mt-md-0">
                <small className="text-muted">
                  Cargado:&nbsp;
                  <Moment format="DD/MM/YYYY HH:mm">{d.updated_at}</Moment>
                </small>
              </Col>
              <Col md="3" className="text-md-end mt-2 mt-md-0">
                {d.url ? (
                  <Button
                    size="sm"
                    color="info"
                    outline
                    href={d.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Descargar ${d.name}`}
                  >
                    <i className="fas fa-download me-2" /> Descargar
                  </Button>
                ) : (
                  <Button size="sm" color="secondary" outline disabled>
                    <i className="fas fa-ban me-2" /> Sin archivo
                  </Button>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      ))}
    </>
  );
};

export default ApplicantDocuments;
